import React from 'react';
import { Section } from './ui/Section';
import { Mail, Download, ShoppingBag, Calendar } from 'lucide-react';
export function DeliverySection() {
  const steps = [{
    icon: ShoppingBag,
    text: 'Compras como cualquier producto digital.'
  }, {
    icon: Download,
    text: 'Al finalizar, verás un botón de descarga en la página de confirmación.'
  }, {
    icon: Mail,
    text: 'También recibirás un email con los enlaces para descargar los 4 PDFs.'
  }, {
    icon: Calendar,
    text: 'Recomendación: empieza mañana con el Día 1 y mantén un horario fijo.'
  }];
  return <Section background="white" data-id="element-11">
      <div className="text-center mb-8 md:mb-12" data-id="element-12">
        <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#2D2A26] mb-3 md:mb-4" data-id="element-13">
          Cómo lo recibes (Shopify)
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8 mb-6 md:mb-10" data-id="element-14">
        {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-15">
            <div className="w-12 h-12 md:w-16 md:h-16 bg-[#F0F4EE] rounded-full flex items-center justify-center mb-3 md:mb-4 text-[#D4836B]" data-id="element-16">
              <step.icon className="h-6 w-6 md:h-8 md:w-8" data-id="element-17" />
            </div>
            <div className="text-sm font-bold text-[#5B7C5B] mb-2" data-id="element-18">
              PASO {index + 1}
            </div>
            <p className="text-sm md:text-base text-[#2D2A26]" data-id="element-19">{step.text}</p>
          </div>)}
      </div>

      <div className="text-center p-4 bg-[#FAF7F2] rounded-lg border border-[#E8E2DA] inline-block w-full" data-id="element-20">
        <p className="text-sm text-[#6B6560]" data-id="element-21">
          Si no encuentras el email, revisa "Promociones/Spam" o escríbenos con
          el número de pedido.
        </p>
      </div>
    </Section>;
}